/*eslint-disable*/
// import fetch from 'unfetch'

function exitRegistry() {

  // fetch('/cart/update.js', {
  //   method: 'POST',
  //   credentials: 'include',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   data: { 'attributes[registry_id]': '', 'attributes[registry_admin]': '' }
  // })
  //   .then(res => res.json()).then((res) => {
  //     document.cookie = 'giftreggie-logged' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;'
  //     document.cookie = 'giftreggie-address' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;'
  //     document.cookie = 'giftreggie_session_cookie' + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;'
  //     if (window.location.href.indexOf('registry/') > -1) {
  //       window.location.href = '/'
  //     } else {
  //       window.location.reload()
  //     }
  //   })

  $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json', data: { 'attributes[registry_id]': '', 'attributes[registry_admin]': '' } }).done(function () {
    document.cookie = 'giftreggie-logged' + '=; path/; expires=Thu, 01-Jan-70 00:00:01 GMT;'
    document.cookie = 'giftreggie-address' + '=; path=/; expires=Thu, 01-Jan-70 00:00:01 GMT;'
    document.cookie = 'giftreggie_session_cookie' + '=; path/; expires=Thu, 01-Jan-70 00:00:01 GMT;'


    if (window.location.href.indexOf('registry/') > -1) {
      window.location.href = '/'
    } else {
      window.location.reload()
    }

  }
  )
}

module.exports = {
  exitRegistry
}



// WEBPACK FOOTER //
// ./src/scripts/utls/registry.js